/* eslint-disable */
import React from 'react';
import { useHistory } from 'react-router-dom';
import './DetailedDomainTile.module.css'
import NewInfoIcon from '../../components/ProcureToPayComp/TileComp/NewInfoIcon';


const DetailedDomainTile = ({ title = "Title", showButton = false, path , detailState,infoIcondata = "" }) => {
    const history = useHistory();

    // const handleDetailClick = () => {
    //     history.push(path);
    // };

    const handleDetailClick = () => {
        if (path) {
          history.push(path, detailState);
        }
      };

    return (
        <div className="domain-tile">
            <div className="domain-tile-header">{title}</div>


            <div className='d-flex justify-content-center align-items-center'>
                {showButton && (
                    <button
                        className="detail-view-btn"
                        onClick={handleDetailClick}
                    >
                        Detailed View <span className="arrow">»</span>
                    </button>
                )}

                {infoIcondata &&
                    <div className='ml-2' style={{ position: "relative", overflow: "visible", zIndex: 50, }}>
                        <NewInfoIcon popupContent={infoIcondata} />
                    </div>
                }
            </div>


        </div>
    );
};

export default DetailedDomainTile;

